export const UpdateCollaboratorApi = Symbol.for('UpdateCollaboratorApi');
